
export type ProductCardType = 'EXCHANGE' | 'P2P' | 'REMITTANCE' | 'CARD' | 'COMEX' | 'COMEX_COMPENSATION';
export interface IProductCard {
  type: ProductCardType,
  title: string,
  subtitle: string,
  btnText: string,
  img: string,
  redirect: IRedirect,
  onlyCountries: string[]
}

export interface IRedirect {
  name: string,
  query?: { [Key: string]: string }
}

export const productCards: IProductCard[] = [
  {
    type: 'EXCHANGE',
    title: 'Comprar y vender USD, EUR y mucho más',
    subtitle: 'Los dólares de tu Cuenta Global pagan 5,0% de interés anual.',
    btnText: 'Ir a Convertir',
    img: "img/coin-exchange-with-flags.svg",
    redirect: { name: 'exchange' },
    onlyCountries: []
  },
  {
    type: 'P2P',
    title: 'Realizar pagos instantáneos',
    subtitle: 'Realiza pagos gratuitos en segundos a otros usuarios, persona o empresa de Global66 desde cualquiera de tus monedas en 7 países.',
    btnText: 'Ir a Enviar',
    img: "img/remittance-p2p.svg",
    redirect: { name: 'transaction', query: { type: 'P2P' } },
    onlyCountries: []
  },
  {
    type: 'REMITTANCE',
    title: 'Realizar transferencias nacionales e internacionales',
    subtitle: 'Paga en moneda local y en USD a proveedores, freelance y colaboradores a +70 destinos, sin comisiones de envío y a un tipo de cambio justo y transparente.',
    btnText: 'Ir a Enviar',
    img: "img/global-transaction.svg",
    redirect: { name: 'transaction', query: { type: 'TRANSACTION' } },
    onlyCountries: []
  },
  {
    type: 'CARD',
    title: 'Pagar con tu Smartcard Business',
    subtitle: 'Paga tus servicios digitales y proveedores en todo el mundo, sin costos de mantención.',
    btnText: 'Ir a Tarjeta',
    img: "img/card-wallets-amounts.svg",
    redirect: { name: 'card' },
    onlyCountries: ['CL']
  },
  {
    type: 'COMEX_COMPENSATION',
    title: 'Has realizado este envío desde una cuenta de compensación',
    subtitle: 'En la sección "COMEX" puedes gestionar tus operaciones y generar los reportes necesarios para los reguladores locales.',
    btnText: 'Ir a COMEX',
    img: "img/universal-collect-money.svg",
    redirect: { name: 'comex-operations' },
    onlyCountries: ['CO']
  },
  {
    type: 'COMEX',
    title: 'Comex',
    subtitle: 'Como intermediario del mercado cambiario autorizado, <span class="font-semibold">reportaremos esta operación con el numeral cambiario</span> que has seleccionado.',
    btnText: 'Ir a COMEX',
    img: "img/terms.svg",
    redirect: { name: 'comex-operations' },
    onlyCountries: ['CO']
  },
  {
    type: 'COMEX',
    title: 'Comex',
    subtitle: 'Recuerda que tienes disponible la <span class="font-semibold">sección “COMEX”</span>, donde podrás gestionar todo lo relacionado con operaciones cambiarías.',
    btnText: 'Ir a COMEX',
    img: "img/global-transaction.svg",
    redirect: { name: 'comex-operations' },
    onlyCountries: ['CO']
  },

]

export default productCards
